import React from 'react'
import { css } from '@emotion/react'
import { bool } from 'prop-types'
import {
  DesignToken,
  SpacingToken,
} from '@livechat/design-system-react-components'
import ListHeader from 'gatsby-theme-marketplace-base/src/components/ProductList/Header/index'
import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

const listHeaderCss = (isAllApps) => (theme) =>
  css`
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: ${theme.colors.white};
    border-bottom: 1px solid var(${DesignToken.BorderBasicTertiary});
    padding: ${isAllApps ? `var(${SpacingToken.Spacing6}) 0 0` : 0};
    margin-bottom: var(${SpacingToken.Spacing3});

    ${mediaQueries.smallScreen(-150)} {
      margin-bottom: var(${SpacingToken.Spacing5});
    }

    ${mediaQueries.mediumScreen()} {
      border-bottom: none;
      margin-bottom: 0;
      padding: ${isAllApps ? `var(${SpacingToken.Spacing6}) 0 0` : 0};
    }

    .collapse__content {
      > div {
        border-bottom: none;

        > div {
          padding-bottom: 0;
        }
      }
    }

    @media (max-width: ${mediaQueries.BASE_SMALL_SIZE - 1}px) {
      .collapse__label-wrapper > div > div {
        width: 100%;

        > span {
          display: none;
        }
      }
    }
  `

const ListHeaderWrapper = (props) => (
  <ListHeader
    css={listHeaderCss(props.isAllApps)}
    {...props}
    showEntireHeader={props.showEntireHeader || false}
    isAllApps={props.isAllApps}
  />
)

ListHeaderWrapper.propTypes = {
  isAllApps: bool,
  showEntireHeader: bool,
}

export default ListHeaderWrapper
